/**
 * Adds clipboard copy feedback for the custom copyable text block.
 */
(function () {
  if (document.documentElement.dataset.twcCopyableTextInitialized === "true") {
    return;
  }

  document.documentElement.dataset.twcCopyableTextInitialized = "true";

  /** @type {WeakMap<Element, number>} */
  const statusTimeouts = new WeakMap();

  document.addEventListener("click", async (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const button = target.closest("[data-twc-copyable-text-button]");

    if (!(button instanceof HTMLElement)) return;

    const text = button.dataset.twcCopyableTextValue;

    if (!text) return;

    await copyText(text);
    showStatus(button);
  });

  /**
   * Copies text to the clipboard with a legacy fallback.
   * @param {string} text
   * @returns {Promise<boolean>}
   */
  async function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch (_error) {
        return copyTextFallback(text);
      }
    }

    return copyTextFallback(text);
  }

  /**
   * Copies text using a hidden textarea fallback.
   * @param {string} text
   * @returns {boolean}
   */
  function copyTextFallback(text) {
    const textarea = document.createElement("textarea");

    textarea.value = text;
    textarea.setAttribute("readonly", "readonly");
    textarea.style.position = "fixed";
    textarea.style.top = "0";
    textarea.style.left = "0";
    textarea.style.opacity = "0";

    document.body.append(textarea);
    textarea.select();

    try {
      return document.execCommand("copy");
    } finally {
      textarea.remove();
    }
  }

  /**
   * Shows the copy confirmation and restarts its animation on every click.
   * @param {HTMLElement} button
   */
  function showStatus(button) {
    const root = button.closest("[data-twc-copyable-text]");
    const status = root?.querySelector(".twc-copyable-text__status");

    if (!(status instanceof HTMLElement)) return;

    const activeTimeout = statusTimeouts.get(status);

    if (activeTimeout) {
      window.clearTimeout(activeTimeout);
    }

    status.hidden = false;
    status.classList.remove("twc-copyable-text__status--visible");
    status.getAnimations().forEach((animation) => animation.cancel());

    window.requestAnimationFrame(() => {
      status.classList.add("twc-copyable-text__status--visible");
    });

    const timeout = window.setTimeout(() => {
      status.classList.remove("twc-copyable-text__status--visible");
      status.hidden = true;
      statusTimeouts.delete(status);
    }, 1800);

    statusTimeouts.set(status, timeout);
  }
})();
